import { combineReducers } from 'redux'

import { augmentt } from '../../_augmentt'
import { assessmentsApi } from '../../_augmentt/services/assessments'
import { customerCollectionsApi } from '../../_augmentt/services/customerCollections'
import { customerGraphResourcesApi } from '../../_augmentt/services/customerGraphResources'
import { featureFlagsApi } from '../../_augmentt/services/featureFlags'
import { hubApi } from '../../_augmentt/services/hub'
import { intuneAppPoliciesApi } from '../../_augmentt/services/intuneAppPolicies'
import { intuneScriptsApi } from '../../_augmentt/services/intuneScripts'
import { intuneMobileAppConfigurationsApi } from '../../_augmentt/services/intuneMobileAppConfigurations'
import { intuneAndroidAppConfigurationSchemasApi } from '../../_augmentt/services/intuneAndroidAppConfigurationSchemas'
import { intuneMobileAppsApi } from '../../_augmentt/services/intuneMobileApps'
import { intuneDeviceHealthScriptsApi } from '../../_augmentt/services/intuneDeviceHealthScripts'
import { intuneWindowsFeaturesOnboardingApi } from '../../_augmentt/services/intuneWindowsFeaturesOnboarding'
import { namedLocationTemplatesApi } from '../../_augmentt/services/namedLocationTemplates'
import { policyTemplateGroupRequirementsApi } from '../../_augmentt/services/policyTemplateGroupRequirements'
import { policyTemplateNamedLocationRequirementsApi } from '../../_augmentt/services/policyTemplateNamedLocationRequirements'
import { purviewDlpApi } from '../../_augmentt/services/purviewDlp'
import { purviewDlpComplianceRuleApi } from '../../_augmentt/services/purviewDlpComplianceRule'
import { purviewRetentionApi } from '../../_augmentt/services/purviewRetention'
import { purviewRetentionLabelApi } from '../../_augmentt/services/purviewRetentionLabel'
import { purviewRetentionRuleApi } from '../../_augmentt/services/purviewRetentionRule'
import { purviewSensitivityLabelApi } from '../../_augmentt/services/purviewSensitivityLabel'
import { secureApi } from '../../_augmentt/services/secure'
import { teamsApi } from '../../_augmentt/services/teams'
import * as selectEntities from './selectEntitiesDuck'

export const rootReducer = combineReducers({
  [featureFlagsApi.reducerPath]: featureFlagsApi.reducer,
  [secureApi.reducerPath]: secureApi.reducer,
  [teamsApi.reducerPath]: teamsApi.reducer,
  [assessmentsApi.reducerPath]: assessmentsApi.reducer,
  [customerCollectionsApi.reducerPath]: customerCollectionsApi.reducer,
  [customerGraphResourcesApi.reducerPath]: customerGraphResourcesApi.reducer,
  [intuneAppPoliciesApi.reducerPath]: intuneAppPoliciesApi.reducer,
  [intuneScriptsApi.reducerPath]: intuneScriptsApi.reducer,
  [intuneMobileAppConfigurationsApi.reducerPath]: intuneMobileAppConfigurationsApi.reducer,
  [intuneMobileAppsApi.reducerPath]: intuneMobileAppsApi.reducer,
  [intuneAndroidAppConfigurationSchemasApi.reducerPath]: intuneAndroidAppConfigurationSchemasApi.reducer,
  [intuneDeviceHealthScriptsApi.reducerPath]: intuneDeviceHealthScriptsApi.reducer,
  [intuneWindowsFeaturesOnboardingApi.reducerPath]: intuneWindowsFeaturesOnboardingApi.reducer,
  [namedLocationTemplatesApi.reducerPath]: namedLocationTemplatesApi.reducer,
  [policyTemplateGroupRequirementsApi.reducerPath]: policyTemplateGroupRequirementsApi.reducer,
  [policyTemplateNamedLocationRequirementsApi.reducerPath]: policyTemplateNamedLocationRequirementsApi.reducer,
  [purviewDlpApi.reducerPath]: purviewDlpApi.reducer,
  [purviewDlpComplianceRuleApi.reducerPath]: purviewDlpComplianceRuleApi.reducer,
  [purviewRetentionApi.reducerPath]: purviewRetentionApi.reducer,
  [purviewRetentionLabelApi.reducerPath]: purviewRetentionLabelApi.reducer,
  [purviewRetentionRuleApi.reducerPath]: purviewRetentionRuleApi.reducer,
  [purviewSensitivityLabelApi.reducerPath]: purviewSensitivityLabelApi.reducer,
  [hubApi.reducerPath]: hubApi.reducer,
  i18n: augmentt.i18n.reducer,
  customers: augmentt.customers.reducer,
  secure: augmentt.secure.reducer,
  licenses: augmentt.licenses.reducer,
  user: augmentt.user.reducer,
  dates: augmentt.dates.reducer,
  employees: augmentt.employees.reducer,
  branding: augmentt.branding.reducer,
  builder: augmentt.builder.reducer,
  uploads: augmentt.uploads.reducer,
  flags: augmentt.flags.reducer,
  externalLinks: augmentt.externalLinks.reducer,
  integrations: augmentt.integrations.reducer,
  exporter: augmentt.exporter.reducer,
  meta: augmentt.meta.reducer,
  reports: augmentt.reports.reducer,
  sessionModal: augmentt.sessionModal.reducer,
  userPermissions: augmentt.userPermissions.reducer,
  table: augmentt.table.reducer,
  subheader: augmentt.subheader.reducer,
  selectEntities: selectEntities.reducer,
})

// eslint-disable-next-line no-empty-function
export function* rootSaga() {}
